import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ first_name: "", last_name: "", email: "", password: "", phone: "", role: "customer" });
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const upd = (k) => (e) => setForm(f => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await register(form);
      nav(u.role === "host" ? "/host" : "/");
    } catch (e2) {
      setErr(e2?.response?.data?.detail || "Registration failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-5 py-14">
      <h1 className="font-display text-3xl font-semibold text-[var(--fpn-navy)]" data-testid="register-title">Create your account</h1>
      <form onSubmit={submit} className="mt-6 space-y-4" data-testid="register-form">
        <div className="grid grid-cols-2 gap-3">
          <input required placeholder="First name" value={form.first_name} onChange={upd("first_name")} className="border border-slate-200 rounded-lg p-3 text-sm" data-testid="register-first-name"/>
          <input required placeholder="Last name" value={form.last_name} onChange={upd("last_name")} className="border border-slate-200 rounded-lg p-3 text-sm" data-testid="register-last-name"/>
        </div>
        <input type="email" required placeholder="Email" value={form.email} onChange={upd("email")} className="w-full border border-slate-200 rounded-lg p-3 text-sm" data-testid="register-email"/>
        <input type="password" required minLength={8} placeholder="Password (min 8 chars)" value={form.password} onChange={upd("password")} className="w-full border border-slate-200 rounded-lg p-3 text-sm" data-testid="register-password"/>
        <input placeholder="Phone (optional)" value={form.phone} onChange={upd("phone")} className="w-full border border-slate-200 rounded-lg p-3 text-sm" data-testid="register-phone"/>
        <div>
          <div className="text-xs font-bold tracking-[0.18em] uppercase text-slate-500 mb-2">I want to</div>
          <div className="flex gap-3">
            {[["customer", "Book parking"], ["host", "List a space"]].map(([v, l]) => (
              <label key={v} className={`flex-1 border rounded-lg p-3 text-sm cursor-pointer text-center ${form.role === v ? "border-[var(--fpn-navy)] bg-slate-50 font-semibold" : "border-slate-200"}`} data-testid={`register-role-${v}`}>
                <input type="radio" name="role" checked={form.role === v} onChange={() => setForm(f => ({ ...f, role: v }))} className="hidden"/>
                {l}
              </label>
            ))}
          </div>
        </div>
        {err && <div className="text-sm text-red-600" data-testid="register-error">{err}</div>}
        <button disabled={loading} className="btn-amber w-full rounded-full py-3 text-sm" data-testid="register-submit">{loading ? "Creating…" : "Create account"}</button>
      </form>
      <p className="text-sm text-slate-600 mt-6">Already have an account? <Link to="/login" className="font-semibold text-[var(--fpn-navy)] underline">Sign in</Link></p>
    </div>
  );
}
